import React from 'react';
import { M38SubmoduleCategoryLinkSectionProps } from 'ui/components/2-molecules/Card/M38SubmoduleCategoryLinkSection/M38SubmoduleCategoryLinkSection';
import { M38MultiCategoryLinksModule } from 'ui/components/3-organisms/M38MultiCategoryLinksModule/M38MultiCategoryLinksModule';

export const M38MultiCategoryLinksModuleFeature: React.FC<Umbraco.M38MultiCategoryLinksModule> = ({ content }) => {
	const { gridColumn } = content?.properties ?? {};
	const { content: linkItems, background, anchor } = content?.properties ?? {};

	const mappedCategoryLinks: M38SubmoduleCategoryLinkSectionProps[] = linkItems?.map(({ content }) => {
		const { title, image, content: text, link, linkSecondary, linkTertiary } = content?.properties ?? {};

		return {
			title,
			image,
			text,
			link,
			linkSecondary,
			linkTertiary,
		};
	});

	return (
		<M38MultiCategoryLinksModule categoryLinks={mappedCategoryLinks} gridColumn={gridColumn} backgroundColorKey={background} anchor={anchor} />
	);
};
